type Candidate<T> = { id: T; screen: { [index: number]: number } };

/**
 * Picks the candidate closest to any of the given screen positions, or undefined if none
 * is within `maxDistanceSq`. Closest rather than first: pins can overlap, and insertion
 * order would otherwise decide which one a tap between two of them selects.
 */
export function nearestWithinRadius<T>(
    candidates: Iterable<Candidate<T>>,
    positions: { x: number; y: number }[],
    maxDistanceSq: number,
): Candidate<T> | undefined {
    let best: Candidate<T> | undefined;
    let bestDistance = maxDistanceSq;

    for (const candidate of candidates) {
        for (const pos of positions) {
            const dx = pos.x - candidate.screen[0];
            const dy = pos.y - candidate.screen[1];
            const distance = dx * dx + dy * dy;
            if (distance < bestDistance) {
                bestDistance = distance;
                best = candidate;
            }
        }
    }

    return best;
}
